import { useState, useMemo, useEffect } from "react";
import { Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import { useDatatableContext } from "@/components/tables/contexts/DatatableContextProvider";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { PREDEFINED_FILTERS, TPredefinedFilter } from "../constants";

const WarehousePredefinedFilters = () => {
  const { getFilterValue, registerFilters } = useDatatableContext();
  const { updateSearchParamsByKey, deleteSearchParamsByKeyValue } = useFiltersBySearchParams();
  const [showAll, setShowAll] = useState(false);

  // Register predefined filter fields
  useEffect(() => {
    registerFilters({
      resizeMode: {
        label: "Resize Mode",
        defaultValue: "",
      },
      resizeEligible: {
        label: "Resize Eligible",
        defaultValue: "",
      },
    });
  }, [registerFilters]);

  // Get current predefined filter values
  const predefinedFilters = useMemo(
    () =>
      ({
        resizeMode: getFilterValue<string>("resizeMode") || "",
        resizeEligible: getFilterValue<string>("resizeEligible") || "",
      }) as Record<string, string>,
    [getFilterValue]
  );

  const visibleOptions = showAll ? PREDEFINED_FILTERS : PREDEFINED_FILTERS.slice(0, 3);

  const onPredefinedFilterSelect = (filter: TPredefinedFilter) => {
    const currentValue = predefinedFilters[filter.key];
    const newValue = currentValue === filter.value ? "" : filter.value;

    // Update search params instead of directly updating context
    // If unsetting the value, delete the search param entirely
    if (newValue === "") {
      deleteSearchParamsByKeyValue({ [filter.key]: undefined });
    } else {
      updateSearchParamsByKey({
        [filter.key]: newValue,
      });
    }
  };

  return (
    <Stack align={"center"} gap={"md"}>
      {visibleOptions.map((option, i) => (
        <Button
          className={"al-font-normal"}
          size={"sm"}
          key={i}
          onClick={() => onPredefinedFilterSelect(option)}
          variant={
            predefinedFilters[option.key] && predefinedFilters[option.key] === option.value
              ? "default"
              : "secondary"
          }
        >
          {option.label}
        </Button>
      ))}
      {PREDEFINED_FILTERS.length > 3 && (
        <Button variant={"ghost"} onClick={() => setShowAll(!showAll)}>
          {showAll ? "Less" : "More"}
        </Button>
      )}
    </Stack>
  );
};

export default WarehousePredefinedFilters;
